import * as React from 'react'

import { contentfulEntryPath } from 'bl_admin/lib/urls'
import Link from 'components/link'
import { TYPE } from '../feed-item-layout'
// @ts-ignore-line
import css from './FeedItemAdminWrapper.scss'

interface FeedItemAdminWrapperProps {
  children: React.ReactNode
  contentfulId: string
  contentfulType: string
}

const FeedItemAdminWrapper = (props: FeedItemAdminWrapperProps) => {
  const { children, contentfulId, contentfulType } = props
  const ContentfulTypeMap: { [key: string]: string } = TYPE

  return (
    <div className={css.AdminWrapper}>
      <div className={css.AdminFeedItemDetails}>
        {Object.keys(ContentfulTypeMap).find(
          (k: string) => ContentfulTypeMap[k] === contentfulType
        )}{' '}
        -{' '}
        <Link newWindow url={contentfulEntryPath(contentfulId)}>
          {contentfulId}
        </Link>
      </div>
      {children}
    </div>
  )
}

export default FeedItemAdminWrapper
